import Stellair from './Stellair.jsx';

export default Stellair;
